import { Alert, Input, Table } from "antd";
import "./SkillsRequestsManagement.scss";
import useSkillsRequestsManagement from "./logic/useSkillsRequestsManagement";

const SkillsRequestsManagement = () => {
  const { skillsRequests, isLoading, error, columns, searchQuery, setSearchQuery } =
    useSkillsRequestsManagement();

  return (
    <div className="skills-requests-container">

      <div className="table-top-section">
        <Input.Search
          placeholder="Search .."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{ width: "300px" }}
          className="search-input"
          allowClear
        />
      </div>
      <div className="skills-content-container">
        {error ? (
          <Alert message="An error has occurred" type="error" showIcon />
        ) : (
          <Table
            columns={columns}
            dataSource={skillsRequests}
            loading={isLoading}
            pagination={{ pageSize: 10 }}
            rowKey="id"
          />
        )}
      </div>
    </div>
  );
};

export default SkillsRequestsManagement;
